module.exports = __webpack_public_path__ + "static/media/icono_seguro.cb406fde.png";